var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"item"},[(!_vm.href)?_vm._t("default"):_c('a',{staticClass:"link",attrs:{"href":_vm.href}},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }